import React from 'react';

import { Typography } from '@mui/material';

import LogoutButton from '../components/buttons/Logout';
import MinimalLayoutWrapper from '../components/shared/MinimalLayoutWrapper';


const NoData = ()=> (
    <MinimalLayoutWrapper>
        <Typography component="h1" variant="h6" sx={{ m: 0 }}>
            No data found for this user.
        </Typography>
        <LogoutButton text="Log Out"/>
    </MinimalLayoutWrapper>
);

export default NoData;
